import { useMemo, useState } from 'react';

import { getPointsByTypes } from '../helpers/getPointsByTypes';
import { getPointTypes } from '../helpers/getPointTypes';
import { StorePoint, PointType } from '../types';

/**
 * Хук для управления магазинами
 */
export function usePointsController(points: StorePoint[]) {
  const pointTypes = useMemo(() => getPointTypes(points), [points]);

  const pointsByTypes = useMemo(
    () => getPointsByTypes(points, pointTypes),
    [points, pointTypes]
  );
  const [selectedPointType, setSelectedPointType] = useState<PointType | null>(
    pointTypes[0]
  );
  /**
   * Видимые магазины после фильтрации
   */
  const visiblePoints = useMemo(() => {
    return selectedPointType === null
      ? pointsByTypes
      : pointsByTypes.filter((points) => {
          return points.city === selectedPointType;
        });
  }, [pointsByTypes, selectedPointType]);
  /**
   * Обработчик изменения города
   */
  const handlePointTypeChange = (type: PointType | null) => {
    setSelectedPointType(type);
  };

  return {
    pointTypes,
    pointsByTypes,
    visiblePoints,
    selectedPointType,
    setSelectedPointType,
    handlePointTypeChange
  };
}
